import React from 'react'
import {Box, Typography, Divider, Button} from '@mui/material'

//assets
import webtexts from '../../../assets/webtexts.json'
import { logoTransparent } from '../../../assets';
import { FlipCard, ScrollFadeInSlideUp, SectionTitle } from '../../../components';
import { image1, image36, image15, image3, image10 } from '../../../assets';



const HomeServices = () => {
  const data = [
    {name:'Residential Spaces', text:webtexts.expertise.find(item => item.id === 'residential')?.text, bgImg: image1},
    {name:'Commercial Properties', text:webtexts.expertise.find(item => item.id === 'commercial')?.text, bgImg: image36},
    {name:'Institutional Buildings', text:webtexts.expertise.find(item => item.id === 'public')?.text, bgImg: image3},
    {name:'Industrial Facilities', text:webtexts.expertise.find(item => item.id === 'industrial')?.text, bgImg: image15},
    {name:'Communal Spaces', text:webtexts.expertise.find(item => item.id === 'community')?.text, bgImg: image10}
  ]

  const ServiceImage = ({ bgImg }) => {
    return (
      <Box
        sx={{
          width: '70%',  // Takes up half the container
          minHeight: '100%', // Ensures it stretches fully
          maxHeight:'inherit',
          display: 'flex',
          alignItems: 'stretch', // Makes sure child elements stretch
          justifyContent: 'center',
          '@media screen and (max-width:762px)':{
            width:'100%',
            maxWidth:'100%'
          }
        }}
      >
        <Box
          component='img'
          src={bgImg}
          sx={{
            width: '100%',
            height: '100%', // Fills the container fully
            objectFit: 'cover', // Ensures the image fills without distortion
            objectPosition: 'center',
            backgroundColor: '#fff',
            '@media screen and (max-width:762px)':{
            width:'100%',
            maxWidth:'100%',
            alignItems:'center',
            height:'auto',
            objectFit:'contain',

          }
          }}
        />
      </Box>
    );
  };

  const ServiceText = ({name, text}) => {
    return( 
    <Box
      sx={{
        alignContent:'center',
        width: '30%',
        minHeight:'100%',
        boxSizing:'border-box',
        '@media screen and (max-width:762px)':{
          width:'100%'
        }
      }}
    >
      <Box
        sx={{
          padding:'1rem',
          display:'flex',
          flexDirection:'column',
          minHeight:'100%',
          width:'auto',
          justifyContent:'center',
          alignItems:'stretch'
        }}
      >
        <Typography
          variant='h1'
          sx={{
            fontFamily:"var(--title-font)",
            fontStyle:'normal',
            fontWeight:'500',
            fontSize:'2.3rem',
            lineHeight:'4rem',
            cursor:'pointer !important',
            letterSpacing:'60',
            color:'#000',
            textAlign:'center',
            '&:hover': {
              color:'#59428A',
            }
          }}
        >
          {name.split(" ")[0] + " "}
          <span
            style={{
              color: "#59428A",
              fontWeight:"1000",
            }}
          >{name.split(" ")[1]}</span>

        </Typography>
        <Typography
          sx={{
            fontFamily: "Gotham",
            color:'#000',
            textAlign:'center',
            
          }}
        >{text}</Typography>

        <Button variant='outlined'
          href='/services'
          sx={{
            width:'50%',
            borderRadius:'0',
            borderColor:'#000',
            borderWidth:'0.01rem',
            marginY:'0.5rem',
            alignSelf:'center',
            '&:hover':{
              backgroundColor:'var(--color-secondary)',
              color:'#fefefe'
          }
          }}
        >
          <Typography
            sx={{
              color:'#000',
              '&:hover':{
                color:'#fefefe'
              }
            }}
          >
            Learn More
          </Typography>
        </Button>
      </Box>
    </Box>
  )}


/// main component starts here
  return (
    <Box
      sx={{
        // backgroundImage:`url(${wide})`,
        backgroundAttachment:'fixed',
        backgroundSize:'cover',
        backgroundRepeat:'no-repeat',
        
      }}
    >
      
      <Box
          sx={{
            position: 'relative',
            top: '50%',
            left: '50%',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            minHeight: '100%',
            zIndex: 1,
            transform: 'translate(-50%, 0)',
            display:'flex',
            flexDirection:'column',
            flexWrap:'wrap',
            // backgroundColor:'rgba(50, 50, 50, 0.9)',
            background:'linear-gradient(to right, #A6A6A6, #fefefe)',
            paddingTop:'1rem'
        }}
      >
        <Box //Logo && brandName
            sx={{
              display:'flex',
              justifyContent:'right',
              marginX:'10rem'
            }}
          >
            
              <Box // logo
                sx={{
                  width:'5rem',
                  alignContent:'center'
                }}
              >
                <FlipCard>
                <Box
                  component='img'
                  src={logoTransparent}
                  sx={{
                    width: '5rem',
                    display:'flex'
                  }}
                />
                </FlipCard>
              </Box>
            
            <Box>
              <Typography
                variant='h1'
                sx={{
                  fontSize:'2rem',
                  fontFamily:"var(--title-font)",
                  textTransform:'Uppercase',
                  fontWeight:'1000',
                  alignContent:'center',
                  alignItems:'center',
                  letterSpacing:'0.5rem',
                  textAlign:'center',
                  lineHeight:'4rem',
                  fontStretch:'expanded',
                  marginX:'1rem',
                  color:'#000'
                }}
              >
                Pangu
              </Typography>
            </Box>

          </Box>
          
        <Box
          sx={{
            width:'100%',
            display:'flex',
            flexDirection:'row',
          }}
        >
          <SectionTitle firstTitleWord='Building' secondTitleWord='solutions' sx={{width:'100%'}}/>
        </Box>

        
        <Box
          sx={{
            maxWidth:'100%'
          }}
        >
          <Box
            sx={{
            }}
          >
            {data.map((item, index) => (
              <>
              <ScrollFadeInSlideUp threshold='0.1'>
              <Box key={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  // minHeight: '40vh', // Set a defined height
                  paddingY:'2rem',
                  '@media screen and (max-width: 762px)': {
                    flexDirection: 'column',
                    minHeight: 'auto', // Allows resizing on mobile
                    maxWidth:'100%'
                  },
                }}
              >
                {index % 2 === 0 ? (
                  <>
                    <ServiceImage bgImg={item.bgImg} />
                    <ServiceText name={item.name} text={item.text} />
                  </>
                ) : (
                  <>
                    <ServiceText name={item.name} text={item.text} />
                    <ServiceImage bgImg={item.bgImg} />
                  </>
                )}
                
              </Box>
              <Divider />
              </ScrollFadeInSlideUp>
              </>
            ))}


          </Box>



        </Box>




      </Box>
    </Box>
  )
}

export default HomeServices